export * from "./fetch";
import { useAPI } from "../../utils/use-api";
import { Endpoint } from "../common/endpoints";
import { useInfiniteAPI, } from "../../utils/use-infinite-api";
export const useRequiredVerificationList = (queryParams, shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.RequiredVerificationList,
        queryParams,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useInfiniteRequiredVerificationList = (queryParams, shouldMakeRequest, swrOptions) => {
    return useInfiniteAPI({
        endpoint: Endpoint.RequiredVerificationList,
        queryParams,
        shouldMakeRequest,
        swrOptions,
    });
};
